import React from 'react';

import type { DeliveryProductDetailsScreenProps } from '../../navigation/AppNavigation.props';
import { DeliveryProductDetails } from './components';

export const DeliveryProductDetailsScreen = ({
  navigation,
  route,
}: DeliveryProductDetailsScreenProps) => {
  const {
    addressId,
    productSlug,
    ingredientIds,
    name: encodedName,
  } = route.params;

  const name = encodedName ? decodeURIComponent(encodedName) : null;
  const decodedIngredientIds = ingredientIds
    ? decodeURIComponent(ingredientIds)
    : null;

  const handleAddLineItemToCart = React.useCallback(() => {
    navigation.replace('Bag');
  }, [navigation]);

  return (
    <DeliveryProductDetails
      addressId={addressId}
      productSlug={productSlug}
      ingredientIds={decodedIngredientIds?.split(',')}
      onAddLineItemToCart={handleAddLineItemToCart}
      name={name}
    />
  );
};
